const RECEIVE_ALL_PROMO_TYPES = 'src/brands/RECEIVE_ALL_PROMO_TYPES' as const;
const CLEAR_ALL_PROMO_TYPES = 'src/brands/CLEAR_ALL_PROMO_TYPES' as const;

export default {
  CLEAR_ALL_PROMO_TYPES,
  RECEIVE_ALL_PROMO_TYPES
};
